import React from "react";
import Header from "./Header/Header";
import Footer from "./footer";
import { useEffect } from "react";
import "../App.css";
function Tech() {
    const formatDurationApprox = (startYear, startMonth) => {
    const start = new Date(startYear, startMonth);
    const now = new Date();

    const months =
        (now.getFullYear() - start.getFullYear()) * 12 +
        (now.getMonth() - start.getMonth());

    const years = months / 12;
    return `~${years.toFixed(1)} yrs`;
};
    useEffect(() => {
        if (
            !document.querySelector("header").classList.contains("headerStick")
        ) {
            document.querySelector("header").classList.add("headerStick");
        }
        window.scroll(0, 0);
    }, []);

    return (
        <div className="AppArt con" style={{ alignItems: "center" }}>
            <Header />
            <div className="techinner techw" style={{ flex: "1 0 auto" }}>
                <h1
                    style={{
                        fontSize: "3.5em",
                        fontFamily: "r-regular",
                        fontWeight: "lighter",
                    }}
                >
                    Syed Ali
                </h1>
                <h5
                    style={{
                        fontSize: "1em",
                        fontFamily: "r-regular",
                        fontWeight: "lighter",
                    }}
                >
                    {formatDurationApprox(2001, 8)}, Bangalore, India
                </h5>
                <h3
                    className="r-regular"
                    style={{ marginTop: "1em", marginBottom: "0.3em" }}
                >
                    Bachelor of Computer Science Engineering,
                    <br />
                    <div
                        style={{
                            fontSize: "0.75em",
                            fontFamily: "r-regular",
                            fontWeight: "lighter",
                        }}
                    >
                        Ramaiah University, Bangalore, 2020-2024
                    </div>
                </h3>
                {/* underline */}
                <h3
                    style={{
                        marginTop: "1em",
                        marginBottom: "0em",
                        fontSize: "2.5em",
                        fontFamily: "r-regular",
                    }}
                >
                    Experience
                </h3>

                <p className="techtext r-medium">
<ul>
    <li>
        <div className="dur">
            Machine Learning Researcher & Music Technology Engineer at{" "}
            <a
                href="https://beatoven.ai"
                target={"_blank"}
                rel="noreferrer"
            >
                beatoven.ai
            </a>
            , <br />
            <div
                style={{
                    fontSize: "0.75em",
                    fontFamily: "r-regular",
                    fontWeight: "lighter",
                }}
            >
                June, 2021 - Present, {formatDurationApprox(2021, 5)}
            </div>
        </div>
        <div
            className="jd"
            style={{
                fontSize: "0.65em",
                textTransform: "capitalize",
            }}
        >
            Training large-scale generative audio foundation models from scratch
            using diffusion and autoregressive architectures in PyTorch;
            large-scale data curation, preprocessing, and augmentation;
            distributed training, embedding models, and MLOps. Previously led
            full-stack platform development, large-scale data ingestion, and
            metadata automation for music and SFX generation systems.
            <br />
        </div>
    </li>

    <li>
        <div className="dur">
            Founder, Tarab Instruments
            <br />
            <div
                style={{
                    fontSize: "0.75em",
                    fontFamily: "r-regular",
                    fontWeight: "lighter",
                }}
            >
                2024 - Present, {formatDurationApprox(2024, 0)}
            </div>
        </div>
        <div className="jd" style={{ fontSize: "0.65em" }}>
            Designing and building custom MIDI controllers, Eurorack modules,
            and guitar pedals; teaching workshops on music electronics,
            synthesis, and DIY audio hardware, bridging creative practice with
            engineering education.
        </div>
    </li>

    <li>
        <div className="dur">
            Musician, Qareebi
            <br />
            <div
                style={{
                    fontSize: "0.75em",
                    fontFamily: "r-regular",
                    fontWeight: "lighter",
                }}
            >
                December, 2018 - Present, {formatDurationApprox(2018, 11)}
            </div>
        </div>
        <div className="jd" style={{ fontSize: "0.65em" }}>
            Electronic, experimental, and ambient music practice; live
            performance and composition.
            <br />
            Previously as IO (2018 - 2020)
        </div>
    </li>

    <li>
        <div className="dur">
            Multimedia Designer, Independent <br />
            <div
                style={{
                    fontSize: "0.75em",
                    fontFamily: "r-regular",
                    fontWeight: "lighter",
                }}
            >
                August, 2019 - Present, {formatDurationApprox(2019, 7)}
            </div>
        </div>
        <div className="jd" style={{ fontSize: "0.65em" }}>
            Print & digital multimedia design, typography, album artwork,
            branding and visual identity; Adobe Creative Cloud (Photoshop,
            Illustrator, After Effects, InDesign).
        </div>
    </li>
</ul>


                </p>
                <p></p>
            </div>
            <Footer />
        </div>
    );
}

export default Tech;
